/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAddressSearchResultDto } from '../models/work-address-search-result-dto';

@Injectable({ providedIn: 'root' })
export class WorkAddressService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `addressV2ControllerSearchAddress()` */
  static readonly AddressV2ControllerSearchAddressPath = '/v2/address/search';

  /**
   * Search for addresses using Google Places API.
   *
   * Search for addresses to help employees find and select proper addresses
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addressV2ControllerSearchAddress()` instead.
   *
   * This method doesn't expect any request body.
   */
  addressV2ControllerSearchAddress$Response(
    params: {

    /**
     * Search query for address (e.g., "Hauptstrasse 1, Zürich")
     */
      query: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkAddressSearchResultDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAddressService.AddressV2ControllerSearchAddressPath, 'get');
    if (params) {
      rb.query('query', params.query, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkAddressSearchResultDto>>;
      })
    );
  }

  /**
   * Search for addresses using Google Places API.
   *
   * Search for addresses to help employees find and select proper addresses
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addressV2ControllerSearchAddress$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  addressV2ControllerSearchAddress(
    params: {

    /**
     * Search query for address (e.g., "Hauptstrasse 1, Zürich")
     */
      query: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkAddressSearchResultDto>> {
    return this.addressV2ControllerSearchAddress$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkAddressSearchResultDto>>): Array<WorkAddressSearchResultDto> => r.body)
    );
  }

  /** Path part for operation `addressV2ControllerReverseSearchAddress()` */
  static readonly AddressV2ControllerReverseSearchAddressPath = '/v2/address/reverse';

  /**
   * Find addresses near a location.
   *
   * Nearest building addresses (Swiss building register via geo.admin.ch), closest first — e.g. for "current location" in the app
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addressV2ControllerReverseSearchAddress()` instead.
   *
   * This method doesn't expect any request body.
   */
  addressV2ControllerReverseSearchAddress$Response(
    params: {

    /**
     * Breitengrad (WGS84)
     */
      latitude: number;

    /**
     * Längengrad (WGS84)
     */
      longitude: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkAddressSearchResultDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAddressService.AddressV2ControllerReverseSearchAddressPath, 'get');
    if (params) {
      rb.query('latitude', params.latitude, {});
      rb.query('longitude', params.longitude, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkAddressSearchResultDto>>;
      })
    );
  }

  /**
   * Find addresses near a location.
   *
   * Nearest building addresses (Swiss building register via geo.admin.ch), closest first — e.g. for "current location" in the app
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addressV2ControllerReverseSearchAddress$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  addressV2ControllerReverseSearchAddress(
    params: {

    /**
     * Breitengrad (WGS84)
     */
      latitude: number;

    /**
     * Längengrad (WGS84)
     */
      longitude: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkAddressSearchResultDto>> {
    return this.addressV2ControllerReverseSearchAddress$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkAddressSearchResultDto>>): Array<WorkAddressSearchResultDto> => r.body)
    );
  }

}
